/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_STUDENTS = '[Student] Get Students',
  GET_STUDENTS_SUCCESS = '[Student] Students Success',
  GET_STUDENTS_FAILED = '[Student] Get Students Failed',

  GET_ASSESSMENT_STUDENT_LIST = '[Student] Get Assessment Student List',
  GET_ASSESSMENT_STUDENT_LIST_SUCCESS = '[Student] Get Assessment Student List Success',
  GET_ASSESSMENT_STUDENT_LIST_FAILED = '[Student] Get Get Assessment Student Failed',

  CREATE_STUDENTS = '[Student] Create Student',
  CREATE_STUDENTS_SUCCESS = '[Student] Create Student Success',
  CREATE_STUDENTS_FAILED = '[Student] Create Student Failed',

  UPDATE_STUDENTS = '[Student] Update Student',
  UPDATE_STUDENTS_SUCCESS = '[Student] Update Student Success',
  UPDATE_STUDENTS_FAILED = '[Student] Update Student Failed',

  GET_STUDENT_FEES = '[Student] Get Student Fees',
  GET_STUDENT_FEES_SUCCESS = '[Student] Get Student Fees Success',
  GET_STUDENT_FEES_FAILED = '[Student] Get Student Fees Failed',

  CREATE_STUDENT_FEES = '[Student] Create Student Fees',
  CREATE_STUDENT_FEES_SUCCESS = '[Student] Create Student Fees Success',
  CREATE_STUDENT_FEES_FAILED = '[Student] Create Student Fees Failed',

  UPDATE_STUDENT_FEES = '[Student] Update Student Fees',
  UPDATE_STUDENT_FEES_SUCCESS = '[Student] Update Student Fees Success',
  UPDATE_STUDENT_FEES_FAILED = '[Student] Update Student Fees Failed',

  GET_STUDENT_PREINLISTMENTS = '[Student] Get Student Preinlistments',
  GET_STUDENT_PREINLISTMENTS_SUCCESS = '[Student] Get Student Preinlistments Success',
  GET_STUDENT_PREINLISTMENTS_FAILED = '[Student] Get Student Preinlistments Failed',

  CREATE_STUDENT_PREINLISTMENTS = '[Student] Create Student Preinlistments',
  CREATE_STUDENT_PREINLISTMENTS_SUCCESS = '[Student] Create Student Preinlistments Success',
  CREATE_STUDENT_PREINLISTMENTS_FAILED = '[Student] Create Student Preinlistments Failed',

  UPDATE_STUDENT_PREINLISTMENTS = '[Student] Update Student Preinlistments',
  UPDATE_STUDENT_PREINLISTMENTS_SUCCESS = '[Student] Update Student Preinlistments Success',
  UPDATE_STUDENT_PREINLISTMENTS_FAILED = '[Student] Update Student Preinlistments Failed',

  GET_GRADE_CONVERSIONS = '[Student] Get Grade Conversions',
  GET_GRADE_CONVERSIONS_SUCCESS = '[Student] Get Grade Conversions Success',
  GET_GRADE_CONVERSIONS_FAILED = '[Student] Get Grade Conversions Failed',

  CREATE_GRADE_CONVERSIONS = '[Student] Create Grade Conversions',
  CREATE_GRADE_CONVERSIONS_SUCCESS = '[Student] Create Grade Conversions Success',
  CREATE_GRADE_CONVERSIONS_FAILED = '[Student] Create Grade Conversions Failed',

  UPDATE_GRADE_CONVERSIONS = '[Student] Update Grade Conversions',
  UPDATE_GRADE_CONVERSIONS_SUCCESS = '[Student] Update Grade Conversions Success',
  UPDATE_GRADE_CONVERSIONS_FAILED = '[Student] Update Grade Conversions Failed',

  GET_SUBJECTS = '[Student] Get Subjects',
  GET_SUBJECTS_SUCCESS = '[Student] Get Subjects Success',
  GET_SUBJECTS_FAILED = '[Student] Get Subjects Failed',

  CREATE_SUBJECTS = '[Student] Create Subjects',
  CREATE_SUBJECTS_SUCCESS = '[Student] Create Subjects Success',
  CREATE_SUBJECTS_FAILED = '[Student] Create Subjects Failed',

  UPDATE_SUBJECTS = '[Student] Update Subjects',
  UPDATE_SUBJECTS_SUCCESS = '[Student] Update Subjects Success',
  UPDATE_SUBJECTS_FAILED = '[Student] Update Subjects Failed',

  GET_STUDENT_APPLICATION_LIST = '[Student] Get Student Application List',
  GET_STUDENT_APPLICATION_LIST_SUCCESS = '[Student] Get Student Application List Success',
  GET_STUDENT_APPLICATION_LIST_FAILED = '[Student] Get Student Application List Failed',

  UPDATE_STUDENT_APPLICATION_STATUS = '[Student] Update Student Application Status',
  UPDATE_STUDENT_APPLICATION_STATUS_SUCCESS = '[Student] Update Student Application Status Success',
  UPDATE_STUDENT_APPLICATION_STATUS_FAILED = '[Student] Update Student Application Status Failed',

  GET_PRE_ENLISTMENT_LIST = '[Student] Get Pre Enlistment List',
  GET_PRE_ENLISTMENT_LIST_SUCCESS = '[Student] Get Pre Enlistment List Success',
  GET_PRE_ENLISTMENT_LIST_FAILED = '[Student] Get Pre Enlistment List Failed',

  UPDATE_PRE_ENLISTMENT_STATUS = '[Student] Update Pre Enlistment Status',
  UPDATE_PRE_ENLISTMENT_STATUS_SUCCESS = '[Student] Update Pre Enlistment Status Success',
  UPDATE_PRE_ENLISTMENT_STATUS_FAILED = '[Student] Update Pre Enlistment Status Failed',

  GET_STUDENT_ASSESSMENT = '[Student] Get Student Assessment',
  GET_STUDENT_ASSESSMENT_SUCCESS = '[Student] Get Student Assessment Success',
  GET_STUDENT_ASSESSMENT_FAILED = '[Student] Get Student Assessment Failed',

  GENERATE_STUDENT_ASSESSMENT = '[Student] Generate Student Assessment',
  GENERATE_STUDENT_ASSESSMENT_SUCCESS = '[Student] Generate Student Assessment Success',
  GENERATE_STUDENT_ASSESSMENT_FAILED = '[Student] Generate Student Assessment Failed',

  GET_STUDENT_LATEST_ASSESSMENT = '[Student] Get Student Latest Assessment',
  GET_STUDENT_LATEST_ASSESSMENT_SUCCESS = '[Student] Get Student Latest Assessment Success',
  GET_STUDENT_LATEST_ASSESSMENT_FAILED = '[Student] Get Student Latest Assessment Failed',

  GET_STUDENT_SCHEDULE = '[Student] Get Student Schedule',
  GET_STUDENT_SCHEDULE_SUCCESS = '[Student] Get Student Schedule Success',
  GET_STUDENT_SCHEDULE_FAILED = '[Student] Get Student Schedule Failed',
}

// STUDENTS ACTIONS
export const getStudents = createAction(
  ActionTypes.GET_STUDENTS,
  props<{ data: any }>()
);

export const getStudentsSuccess = createAction(
	ActionTypes.GET_STUDENTS_SUCCESS,
  props<{ data: any }>()
);

export const getStudentsFailed = createAction(
  ActionTypes.GET_STUDENTS_FAILED,
  props<{ data: any }>()
);

export const getAssessmentStudentList = createAction(
  ActionTypes.GET_ASSESSMENT_STUDENT_LIST,
  props<{ data: any }>()
);

export const getAssessmentStudentListSuccess = createAction(
	ActionTypes.GET_ASSESSMENT_STUDENT_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getAssessmentStudentListFailed = createAction(
  ActionTypes.GET_ASSESSMENT_STUDENT_LIST_FAILED,
  props<{ data: any }>()
);

export const createStudents = createAction(
  ActionTypes.CREATE_STUDENTS,
  props<{ data: any }>()
);

export const createStudentsSuccess = createAction(
	ActionTypes.CREATE_STUDENTS_SUCCESS,
  props<{ data: any }>()
);

export const createStudentsFailed = createAction(
  ActionTypes.CREATE_STUDENTS_FAILED,
  props<{ data: any }>()
);

export const updateStudents = createAction(
  ActionTypes.UPDATE_STUDENTS,
  props<{ data: any, studentId: any }>()
);

export const updateStudentsSuccess = createAction(
	ActionTypes.UPDATE_STUDENTS_SUCCESS,
  props<{ data: any }>()
);

export const updateStudentsFailed = createAction(
  ActionTypes.UPDATE_STUDENTS_FAILED,
  props<{ data: any }>()
);

// STUDENT FEES ACTIONS
export const getStudentFees = createAction(
  ActionTypes.GET_STUDENT_FEES
);

export const getStudentFeesSuccess = createAction(
	ActionTypes.GET_STUDENT_FEES_SUCCESS,
  props<{ data: any }>()
);

export const getStudentFeesFailed = createAction(
  ActionTypes.GET_STUDENT_FEES_FAILED,
  props<{ data: any }>()
);

export const createStudentFees = createAction(
  ActionTypes.CREATE_STUDENT_FEES,
  props<{ data: any }>()
);

export const createStudentFeesSuccess = createAction(
	ActionTypes.CREATE_STUDENT_FEES_SUCCESS,
  props<{ data: any }>()
);

export const createStudentFeesFailed = createAction(
  ActionTypes.CREATE_STUDENT_FEES_FAILED,
  props<{ data: any }>()
);

export const updateStudentFees = createAction(
  ActionTypes.UPDATE_STUDENT_FEES,
  props<{ data: any, buildingId: any }>()
);

export const updateStudentFeesSuccess = createAction(
	ActionTypes.UPDATE_STUDENT_FEES_SUCCESS,
  props<{ data: any }>()
);

export const updateStudentFeesFailed = createAction(
  ActionTypes.UPDATE_STUDENT_FEES_FAILED,
  props<{ data: any }>()
);

// SCHOOL YEAR ACTIONS
export const getStudentPreinlistments = createAction(
  ActionTypes.GET_STUDENT_PREINLISTMENTS
);

export const getStudentPreinlistmentsSuccess = createAction(
	ActionTypes.GET_STUDENT_PREINLISTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const getStudentPreinlistmentsFailed = createAction(
  ActionTypes.GET_STUDENT_PREINLISTMENTS_FAILED,
  props<{ data: any }>()
);

export const createStudentPreinlistments = createAction(
  ActionTypes.CREATE_STUDENT_PREINLISTMENTS,
  props<{ data: any }>()
);

export const createStudentPreinlistmentsSuccess = createAction(
	ActionTypes.CREATE_STUDENT_PREINLISTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const createStudentPreinlistmentsFailed = createAction(
  ActionTypes.CREATE_STUDENT_PREINLISTMENTS_FAILED,
  props<{ data: any }>()
);

export const updateStudentPreinlistments = createAction(
  ActionTypes.UPDATE_STUDENT_PREINLISTMENTS,
  props<{ data: any, roomId: any }>()
);

export const updateStudentPreinlistmentsSuccess = createAction(
	ActionTypes.UPDATE_STUDENT_PREINLISTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const updateStudentPreinlistmentsFailed = createAction(
  ActionTypes.UPDATE_STUDENT_PREINLISTMENTS_FAILED,
  props<{ data: any }>()
);

// GRADE CONVERSIONS ACTIONS
export const getGradeConversions = createAction(
  ActionTypes.GET_GRADE_CONVERSIONS
);

export const getGradeConversionsSuccess = createAction(
	ActionTypes.GET_GRADE_CONVERSIONS_SUCCESS,
  props<{ data: any }>()
);

export const getGradeConversionsFailed = createAction(
  ActionTypes.GET_GRADE_CONVERSIONS_FAILED,
  props<{ data: any }>()
);

export const createGradeConversions = createAction(
  ActionTypes.CREATE_GRADE_CONVERSIONS,
  props<{ data: any }>()
);

export const createGradeConversionsSuccess = createAction(
	ActionTypes.CREATE_GRADE_CONVERSIONS_SUCCESS,
  props<{ data: any }>()
);

export const createGradeConversionsFailed = createAction(
  ActionTypes.CREATE_GRADE_CONVERSIONS_FAILED,
  props<{ data: any }>()
);

export const updateGradeConversions = createAction(
  ActionTypes.UPDATE_GRADE_CONVERSIONS,
  props<{ data: any, collegeId: any }>()
);

export const updateGradeConversionsSuccess = createAction(
	ActionTypes.UPDATE_GRADE_CONVERSIONS_SUCCESS,
  props<{ data: any }>()
);

export const updateGradeConversionsFailed = createAction(
  ActionTypes.UPDATE_GRADE_CONVERSIONS_FAILED,
  props<{ data: any }>()
);

// GET SUBJECTS ACTIONS
export const getSubjects = createAction(
  ActionTypes.GET_SUBJECTS
);

export const getSubjectsSuccess = createAction(
	ActionTypes.GET_SUBJECTS_SUCCESS,
  props<{ data: any }>()
);

export const getSubjectsFailed = createAction(
  ActionTypes.GET_SUBJECTS_FAILED,
  props<{ data: any }>()
);

export const createSubjects = createAction(
  ActionTypes.CREATE_SUBJECTS,
  props<{ data: any }>()
);

export const createSubjectsSuccess = createAction(
	ActionTypes.CREATE_SUBJECTS_SUCCESS,
  props<{ data: any }>()
);

export const createSubjectsFailed = createAction(
  ActionTypes.CREATE_SUBJECTS_FAILED,
  props<{ data: any }>()
);

export const updateSubjects = createAction(
  ActionTypes.UPDATE_SUBJECTS,
  props<{ data: any, departmentId: any }>()
);

export const updateSubjectsSucess = createAction(
	ActionTypes.UPDATE_SUBJECTS_SUCCESS,
  props<{ data: any }>()
);

export const updateSubjectsFailed = createAction(
  ActionTypes.UPDATE_SUBJECTS_FAILED,
  props<{ data: any }>()
);

// STUDENT APPLICATION ACTIONS
export const getStudentApplicationList = createAction(
  ActionTypes.GET_STUDENT_APPLICATION_LIST,
  props<{ data: any }>()
);

export const getStudentApplicationListSuccess = createAction(
	ActionTypes.GET_STUDENT_APPLICATION_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getStudentApplicationListFailed = createAction(
  ActionTypes.GET_STUDENT_APPLICATION_LIST_FAILED,
  props<{ data: any }>()
);

export const updateApplicationStatus = createAction(
  ActionTypes.UPDATE_STUDENT_APPLICATION_STATUS,
  props<{ applicationId: any, data: any, schoolYearId: any }>()
);

export const updateApplicationStatusSuccess = createAction(
	ActionTypes.UPDATE_STUDENT_APPLICATION_STATUS_SUCCESS,
  props<{ applicationId: any, data: any, schoolYearId: any }>()
);

export const updateApplicationStatusFailed = createAction(
  ActionTypes.UPDATE_STUDENT_APPLICATION_STATUS_FAILED,
  props<{ data: any }>()
);

// PRE ENLISTMENT ACTIONS
export const getPreEnlistmentList = createAction(
  ActionTypes.GET_PRE_ENLISTMENT_LIST,
  props<{ data: any }>()
);

export const getPreEnlistmentListSuccess = createAction(
	ActionTypes.GET_PRE_ENLISTMENT_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getPreEnlistmentListFailed = createAction(
  ActionTypes.GET_PRE_ENLISTMENT_LIST_FAILED,
  props<{ data: any }>()
);

export const updatePreEnlistmentStatus = createAction(
  ActionTypes.UPDATE_PRE_ENLISTMENT_STATUS,
  props<{ preEnlistmentId: any, data: any, schoolYearId: any }>()
);

export const updatePreEnlistmentStatusSuccess = createAction(
	ActionTypes.UPDATE_PRE_ENLISTMENT_STATUS_SUCCESS,
  props<{ preEnlistmentId: any, data: any, schoolYearId: any }>()
);

export const updatePreEnlistmentStatusFailed = createAction(
  ActionTypes.UPDATE_PRE_ENLISTMENT_STATUS_FAILED,
  props<{ data: any }>()
);

// ASSESSMENT ACTIONS
export const getStudentAssessment = createAction(
  ActionTypes.GET_STUDENT_ASSESSMENT,
  props<{ assessment_id: any }>()
);

export const getStudentAssessmentSuccess = createAction(
	ActionTypes.GET_STUDENT_ASSESSMENT_SUCCESS,
  props<{ data: any }>()
);

export const getStudentAssessmentFailed = createAction(
  ActionTypes.GET_STUDENT_ASSESSMENT_FAILED,
  props<{ data: any }>()
);

export const generateStudentAssessment = createAction(
  ActionTypes.GENERATE_STUDENT_ASSESSMENT,
  props<{ student_id: any, data: any }>()
);

export const generateStudentAssessmentSuccess = createAction(
	ActionTypes.GENERATE_STUDENT_ASSESSMENT_SUCCESS,
  props<{ student_id: any, data: any }>()
);

export const generateStudentAssessmentFailed = createAction(
  ActionTypes.GENERATE_STUDENT_ASSESSMENT_FAILED,
  props<{ data: any }>()
);

export const getStudentLatestAssessment = createAction(
  ActionTypes.GET_STUDENT_LATEST_ASSESSMENT,
  props<{ student_id: any }>()
);

export const getStudentLatestAssessmentSuccess = createAction(
	ActionTypes.GET_STUDENT_LATEST_ASSESSMENT_SUCCESS,
  props<{ data: any }>()
);

export const getStudentLatestAssessmentFailed = createAction(
  ActionTypes.GET_STUDENT_LATEST_ASSESSMENT_FAILED,
  props<{ data: any }>()
);

export const getStudentSchedule = createAction(
  ActionTypes.GET_STUDENT_SCHEDULE,
  props<{ student_id: any, term_id: any }>()
);

export const getStudentScheduleSuccess = createAction(
	ActionTypes.GET_STUDENT_SCHEDULE_SUCCESS,
  props<{ data: any }>()
);

export const getStudentScheduleFailed = createAction(
  ActionTypes.GET_STUDENT_SCHEDULE_FAILED,
  props<{ data: any }>()
);